// Module
var code = "<div class=\"appOverview\"> <h2>App Overview</h2> <div class=\"appOverviewTable\"></div> </div> <div class=\"nodeOverview\"> <h2>Node Overview</h2> <div class=\"nodeOverviewTable\"></div> </div> ";
// Exports
export default code;